module.exports = __webpack_public_path__ + "static/media/Claremont Dr, San Bruno, CA1.8a7ba464.jpg";